import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export type AccordionItemData = {
  title: string;
  body: string;
};
type AccordionProps = {
  items: AccordionItemData[];
  numbered?: boolean;
  startIndex?: number;
  accent?: 'teal' | 'orange';
};
export function Accordion({
  items,
  numbered = false,
  startIndex = 1,
  accent = 'teal'
}: AccordionProps) {
  const [open, setOpen] = useState<number | null>(null);
  const ring = accent === 'orange' ? 'border-orange-400/25' : 'border-teal-300/20';
  const chip = accent === 'orange' ? 'bg-orange-500/20 text-orange-200' : 'bg-teal-400/20 text-teal-100';
  return <ul className="space-y-2" data-id="element-16" data-mp="2s2sg7b1ah2qy">
      {items.map((item, i) => {
      const isOpen = open === i;
      return <li key={item.title} className={`overflow-hidden rounded-xl border ${ring} bg-[#0b2b2e]/80 backdrop-blur-sm`} data-id="element-17" data-mp="11re3cafqb6g5" data-mpi={i}>
            <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center gap-3 px-3.5 py-3 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-300" data-id="element-18" data-mp="3g4dngga1ww14">
              {numbered ? <span className={`flex h-6 w-6 flex-none items-center justify-center rounded-md text-[11px] font-bold ${chip}`} data-id="element-19" data-mp="3utrz5v13npjo">
                  {startIndex + i}
                </span> : null}
              <span className="flex-1 font-display text-[13.5px] font-bold leading-snug text-white" data-id="element-20" data-mp="7q54lzxbzjm5">
                {item.title}
              </span>
              <ChevronDownIcon className={`h-4 w-4 flex-none text-teal-200 transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-21" data-mp="hlf5gkbztkyc" />
            </button>
            <AnimatePresence initial={false} data-id="element-22" data-mp="2jed26r8w4xok">
              {isOpen ? <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: 'easeOut'
          }} data-id="element-23" data-mp="2bcdm9z56z9p7">
                  <p className="border-t border-white/5 px-3.5 py-3 text-[13px] leading-relaxed text-teal-50/80" data-id="element-24" data-mp="2q9mrnwrbydzx">
                    {item.body}
                  </p>
                </motion.div> : null}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}